/* import __COLOCATED_TEMPLATE__ from './continent-filter.hbs'; */
/* RESPONSIBLE TEAM: team-reporting */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { AVAILABLE_CONTINENT_MAPPINGS } from 'embercom/lib/reporting/flexible/constants';
import { tracked } from '@glimmer/tracking';
import { REPORTING_FILTER_SELECT_ALL } from 'embercom/lib/reporting/flexible/constants';

export default class ContinentFilter extends Component {
  @service intercomEventService;
  @tracked label = this.currentLabel;
  // store the selection here so that the UI doesn't update until the drop down is closed
  selectedDropdownItems = this.args.selected;

  get items() {
    return this.groupList;
  }

  get selectedContinents() {
    return this.selectedDropdownItems.filter((item) => item !== REPORTING_FILTER_SELECT_ALL);
  }

  get allItems() {
    return Object.entries(AVAILABLE_CONTINENT_MAPPINGS).map(([value, text]) => ({
      text,
      value,
      icon: 'globe',
      isSelected: this.args.selected.includes(value),
    }));
  }

  get groupList() {
    return [
      {
        heading: 'Continents',
        items: this.allItems,
      },
    ];
  }

  get currentLabel() {
    if (this.selectedContinents.length === 0) {
      return 'is Any';
    }

    let continentNames = this.selectedContinents.map((continentId) => {
      return AVAILABLE_CONTINENT_MAPPINGS[continentId];
    });
    return `is ${continentNames.join(', ')}`;
  }

  @action
  onClose() {
    if (!this.selectedDropdownItems.length) {
      this.selectedDropdownItems = [REPORTING_FILTER_SELECT_ALL];
    }

    this.intercomEventService.trackAnalyticsEvent({
      action: 'filtered_continent',
      object: this.args.analyticsObject,
      continent: this.selectedContinents,
    });

    this.args.setSelected(this.selectedDropdownItems);
    this.label = this.currentLabel;
  }

  @action
  removeFilter() {
    this.selectedDropdownItems = [];
    this.args.removeFilter();
  }
}
